import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { BaseAuthService } from '@stillmandigital/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseAuthService {
  protected userTokenKey = 'HURON.USER_TOKEN_KEY';

  public loginUrl = 'login';

  public override logOut() {
    Sentry.setUser(null);
    super.logOut();
  }
}
